import React, { useEffect } from 'react';
import { Modal, ModalBody, Row, Col, Input, Form } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import { useForm, Controller } from 'react-hook-form';
import { SpaceItens, Hr } from 'views/ProtocolConfiguration/styled';
import { ErrorMessage } from '@hookform/error-message';
import FlexSelect from 'components/Inputs/FlexSelect';
import { ruleFieldTypes } from 'variables/typeForRules';

export const EntityStageRulesDefinition = ({
  isModalRuleOpen,
  toggleRuleModal,
  setRuleList,
  ruleToEdit = null,
  fields = []
}) => {
  const filteredFields = fields.filter((field) => field.type === 'LIST');
  const { control, errors, setValue, handleSubmit, reset } = useForm();

  const closeRuleModal = () => {
    reset();
    toggleRuleModal();
  };

  useEffect(() => {
    if (ruleToEdit) {
      reset(ruleToEdit);
    }
  }, [ruleToEdit, reset]);

  const onSubmit = (data) => {
    data.scoreToPass = +data.scoreToPass;
    if (ruleToEdit) {
      setRuleList((prev) => {
        const newRuleList = [...prev];
        newRuleList[ruleToEdit.index] = data;
        return newRuleList;
      });
    }
    setRuleList((prev) => {
      const newRuleList = prev.filter((rule) => rule.name !== data.name);
      newRuleList.push({
        name: data.name,
        fields: data.fields,
        scoreToPass: data.scoreToPass,
        type: data.type
      });
      return newRuleList;
    });
    closeRuleModal();
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        isOpen={isModalRuleOpen}
        toggle={() => { }}
        style={{ width: '50vw', maxWidth: ' 50rem' }}
      >
        <div className="modal-header">
          <h6
            className="modal-title"
            id="modal-title-default"
            style={{
              width: '100%'
            }}
          >
            Definição de regras
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={closeRuleModal}
          >
            <span aria-hidden={true}>x</span>
          </button>
        </div>
        <ModalBody>
          <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-12">
              <Col md="12">
                <label className="form-control-label">Nome*</label>
                <Controller
                  as={Input}
                  control={control}
                  name="name"
                  defaultValue={''}
                  rules={{
                    required: 'Nome é um campo obrigatório'
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="name"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
              <Col sm="12">
                <label className="form-control-label">Tipo</label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={ruleFieldTypes}
                      isMulti={false}
                      value={props.value}
                      valueController={setValue}
                      closeMenuOnSelect={true}
                      fieldName="type"
                      labelName="label"
                      valueName="value"
                      isClearable={true}
                      noOptionsMessage={() => 'Nenhum valor para ser exibido'}
                    />
                  )}
                  control={control}
                  name="type"
                  defaultValue=""
                />
                <ErrorMessage
                  errors={errors}
                  name="type"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
              <Col md="12">
                <label className="form-control-label">
                  Campos Selecionados*
                </label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={filteredFields}
                      isMulti={true}
                      value={props.value}
                      valueController={setValue}
                      fieldName="fields"
                      labelName="label"
                      valueName="id"
                      isClearable={true}
                      noOptionsMessage={() => 'Nenhum campo para ser exibido'}
                    />
                  )}
                  control={control}
                  name="fields"
                  defaultValue=""
                  rules={{
                    required: 'Selecione pelo menos um campo'
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="fields"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
              <Col sm="12">
                <label className="form-control-label">Pontuação de corte</label>
                <Controller
                  as={
                    <Input
                      type="number"
                      min="0"
                      step="1"
                      defaultValue={'0'}
                      placeholder="Pontuação de Corte"
                    />
                  }
                  control={control}
                  name="scoreToPass"
                  defaultValue=""
                />
                <ErrorMessage
                  errors={errors}
                  name="scoreToPass"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
            </Row>
          </Form>
          <SpaceItens />
          <Hr />
          <>
            <ReactButton
              btnColor="confirmation"
              type="submit"
              form="form"
              onClick={handleSubmit(onSubmit)}
            >
              Salvar
            </ReactButton>
            <ReactButton btnColor="cancelation" onClick={closeRuleModal}>
              Cancelar
            </ReactButton>
          </>
        </ModalBody>
      </Modal>
    </>
  );
};
